var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartMedicinesInUseCard_1;
import { Avatar, Card } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import MyChartMedicinesInUseCardAPI from './my-chart-medicines-in-use-card-api';
import './my-chart-medicines-in-use-card.css';
let MyChartMedicinesInUseCard = MyChartMedicinesInUseCard_1 = class MyChartMedicinesInUseCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClickSelection = () => {
            if (this.props.allergie != null) {
                this.handleClickAllergie();
            }
            else {
                this.handleClickMedicine();
            }
        };
        this.handleClickMedicine = () => {
            const { onClick, nrSequence, medicine, dtStart, dose, interval } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dose,
                        dtStart,
                        interval,
                        medicine,
                        nrSequence,
                    }
                }));
            }
        };
        this.handleClickAllergie = () => {
            const { onClick, nrSequence, allergie, classification, condition, intensity } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        allergie,
                        classification,
                        condition,
                        intensity,
                        nrSequence,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        className: string,
        contentClassName: string,
        firstTitle: string,
        onClick: eventListener,
        secondTitle: string,
        thirdTitle: string,
        uuid: string,
    }; }
    static { this.defaultProps = {
        width: 12,
    }; }
    render() {
        const { allergie, medicine, dtStart, dose, classification, intensity, uuid, className, contentClassName, firstTitle, secondTitle, thirdTitle, width = MyChartMedicinesInUseCard_1.defaultProps.width } = this.props;
        const dtStartFormatted = ModelService.format('date', dtStart, { type: 'shortDate' });
        const firstSubtitle = allergie ?? medicine;
        const secondSubtitle = classification ?? dtStartFormatted;
        const thirdSubtitle = intensity ?? dose;
        const contentClass = `card-content ${contentClassName}`;
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.NONE, className: `my-chart-card ${className || ''}`, width: width, onClick: () => this.handleClickSelection() },
            React.createElement("div", { className: contentClass },
                React.createElement("div", { className: "avatar-area" },
                    React.createElement(Avatar, { title: `${MessageService.translate(firstTitle)}:`, subtitle: firstSubtitle, hideImage: true }))),
            React.createElement("div", { className: contentClass },
                React.createElement("div", { className: "avatar-area" },
                    React.createElement(Avatar, { title: `${MessageService.translate(secondTitle)}:`, subtitle: secondSubtitle, hideImage: true }))),
            React.createElement("div", { className: contentClass },
                React.createElement("div", { className: "avatar-area" },
                    React.createElement(Avatar, { title: `${MessageService.translate(thirdTitle)}:`, subtitle: thirdSubtitle, hideImage: true })))));
    }
};
MyChartMedicinesInUseCard = MyChartMedicinesInUseCard_1 = __decorate([
    AwesomeComponent({ api: MyChartMedicinesInUseCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartMedicinesInUseCard);
export default MyChartMedicinesInUseCard;
//# sourceMappingURL=my-chart-medicines-in-use-card.js.map